import { motion } from "framer-motion";

/**
 * GlowPulse — two concentric expanding rings of primary-color glow.
 * Meant to be re-mounted (via `key`) whenever a new number is revealed.
 *
 * Design: soft, magical, elegant. Not casino-flashy.
 */
export default function GlowPulse() {
  return (
    <div
      aria-hidden
      className="absolute inset-0 pointer-events-none flex items-center justify-center"
    >
      {/* First ring — bright core */}
      <motion.span
        initial={{ scale: 0.1, opacity: 0.9 }}
        animate={{ scale: 3.2, opacity: 0 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="absolute rounded-full"
        style={{
          width: 320,
          height: 320,
          background:
            "radial-gradient(circle, var(--ic-primary-glow) 0%, transparent 60%)",
          filter: "blur(6px)",
        }}
      />
      {/* Second ring — trailing wash */}
      <motion.span
        initial={{ scale: 0.4, opacity: 0.65 }}
        animate={{ scale: 4.2, opacity: 0 }}
        transition={{ duration: 1.2, ease: "easeOut", delay: 0.08 }}
        className="absolute rounded-full"
        style={{
          width: 320,
          height: 320,
          background:
            "radial-gradient(circle, var(--ic-primary-glow) 0%, transparent 70%)",
          filter: "blur(14px)",
        }}
      />
    </div>
  );
}
